import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Player } from '@lottiefiles/react-lottie-player';

import { BirdAnimation, RocketAnimation } from '@common/assets';
import { getPercetageValue } from '../../utils';

const Wrapper = styled(Box)<{ end: string }>`
  position: absolute;
  bottom: -170px;
  transform: ${({ end }) => (end === 'true' ? 'translateX(-85%)' : 'translateX(-50%)')};
`;

const LottiePlayer = styled(Player)`
  width: 55px;
  height: 55px;
`;

const Container = styled(Box)<{ color: string }>`
  position: relative;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 10px 12px 6px 2px;
  border-radius: 12px;
  border: 2px solid;
  border-color: ${({ color }) => color};
  background-color: #fff;
  width: fit-content;
`;

const VerticalDashLine = styled(Box)<{ color: string; end: string }>`
  width: 0px;
  height: 128px;
  border-left: 4px dashed;
  border-color: ${({ color }) => color};
  position: absolute;
  top: -128px;
  right: 48%;
  right: ${({ end }) => (end === 'true' ? '12%' : '48%')};
`;

const Heading = styled(Typography)`
  color: #0f1629;
  font-size: 16px;
  font-weight: bold;
  margin-left: 14px;
`;

const BodyText = styled(Heading)`
  color: #0f1629;
  font-size: 16px;
  font-weight: 400;
`;

type Props = {
  type: 'personal_goal' | 'todays_goal';
  goal: number;
  rulerSize: number;
  heading?: string;
};

export const GoalIndicator = ({ goal, rulerSize, type, heading }: Props) => {
  const isPersonalGoal = type === 'personal_goal';

  const title = isPersonalGoal ? 'Personal Goal' : "Today's Goal";
  const animation = isPersonalGoal ? RocketAnimation : BirdAnimation;
  const color = isPersonalGoal ? '#EA0BBD' : '#0DCBFF';
  const isEnd = goal === rulerSize;

  return (
    <Wrapper end={isEnd.toString()} left={`${getPercetageValue(rulerSize, goal, true)}%`}>
      <Container color={color}>
        <Heading>{heading ?? title}</Heading>
        <Stack direction="row" spacing={1} mt={1}>
          <LottiePlayer autoplay loop src={animation} />
          <BodyText>
            {goal}&nbsp;Lessons <br />
            Complete
          </BodyText>
        </Stack>
        <VerticalDashLine end={isEnd.toString()} color={color} />
      </Container>
    </Wrapper>
  );
};
